import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadService } from 'src/app/shared/store/lead/lead.service';
import { LeadDetailModel } from 'src/app/shared/store/lead/types';
import { ReferralCampaign } from '../../../../../../shared/store/campaign/types';

@Component({
    selector: 'app-lead-details-marketing',
    templateUrl: './lead-details-marketing.component.html',
    styleUrls: ['./lead-details-marketing.component.scss'],
    standalone: false
})
export class LeadDetailsMarketingComponent implements OnInit {
  leadDetail$: Observable<LeadDetailModel>;
  protected readonly ReferralCampaign = ReferralCampaign;

  constructor(private readonly leadService: LeadService) {}

  ngOnInit(): void {
    this.leadDetail$ = this.leadService.getByUniqueId.value$;
  }
}
